<!-- 组件说明 -->
<template>
  <div class="deal">
    认购：{{ moment(followItem.subscribeTime).format("YYYY/MM/DD") }}
  </div>
</template>

<script>
import moment from "moment";
export default {
  props: {
    followItem: {
      type: Object,
    },
  },
  data() {
    return {
      moment,
    };
  },
};
</script>

<style lang="scss" scoped>
.deal {
  font-size: 28px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
}
</style>
